import React, { useState, useEffect } from "react";
import { PdfProfiGenerator } from "./PdfProfiGenerator";
import { Button,Space } from "antd";
import { PDFViewer } from "@react-pdf/renderer";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PendingComp } from "../Helper/ProgressComp";
import {
  RollbackOutlined,
  CopyOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";

export const PdfViewHome = () => {
  const navigate = useNavigate();
  const [isPending, setIsPending] = useState(true);
  const [triggered, setTriggered] = useState(false);
  const [homeLink, setHomeLink] = useState(["PdfTestHome", "/PdfTestHome"]);
  const [copyState, setCopyState] = useState(false);
  const [aktCopyText, setAktCopyText] = useState();

  const pdfProfidaten = useSelector((state) => state.pdf.value);
  /*
  const jsonData = window.sessionStorage.getItem("pdf");
  let pdf=null;
  if (jsonData) {
    pdf = JSON.parse(jsonData); // Die Daten müssen von der Zeichenkette wieder in ein Objekt konvertiert werden
    console.log("pdf", pdf);
  }
  const pdfProfidaten=pdf;
  */
  useEffect(() => {
    if (pdfProfidaten === undefined || pdfProfidaten === null) {
      navigate("/"); // wenn direkt aufgerufen und keine Daten da sind
    } else {
      setHomeLink(pdfProfidaten.HomeLink);
    }
    if (pdfProfidaten !== null) {
      let text = "";

      const getCsvText2DArray = (datenArray) => {
        let text = "";

        datenArray.forEach((group, groupIndex) => {
          // Iteration über die Zeilen des zweidimensionalen Arrays
          group.texte.forEach((row, rowIndex) => {
            // Iteration über die Spalten jedes Elements der Zeile
            const rowText = row
              .map((cell, cellIndex) => {
                let cellText;
                if (typeof cell !== "number" || isNaN(cell)) cellText = cell;
                else cellText = cell.toFixed(group.nachkommas[cellIndex]);
                if (cellText)
                  return cellText.toString().includes(";")
                    ? cellText.toString().replace(";", ",")
                    : cellText.toString();
                return "";
              })
              .join(";");
            text += rowText + "\n"; // Hinzufügen der Zeile zum Text mit einem Zeilenumbruch
          });
          text += "\n";
        });
        return text;
      };
      text +=
        getCsvText2DArray([{ texte: [pdfProfidaten.PdfHead.text] }]) +
        getCsvText2DArray(pdfProfidaten.PdfHeadDatenArray) +
        getCsvText2DArray(pdfProfidaten.PdfDatenArray);

      setAktCopyText(text);
    }
  }, [pdfProfidaten, navigate]);

  // useEffect, um die Verzögerung auszulösen, wenn triggered true wird
  useEffect(() => {
    if (triggered) {
      const timeoutId = setTimeout(() => {
        setIsPending(false);
      }, 500);

      // Clean-up-Funktion, um den Timeout zu löschen, wenn die Komponente unmountet wird oder der Zustand geändert wird
      return () => clearTimeout(timeoutId);
    }
  }, [triggered]);

  const handlePennding = (value) => {
    setTriggered(true);
  };

  return (
    <>
      <div className="page-pdfViewHome">
        <PDFViewer
          style={{ width: "Calc(100% - 6px)", height: "Calc(100% - 6px)" }}
        >
          {pdfProfidaten && (
            <PdfProfiGenerator
              pdfProfidaten={pdfProfidaten}
              handlePennding={handlePennding}
            />
          )}
        </PDFViewer>
        <div style={{ position: "absolute", top: 65, left: 10, zIndex: 700 }}>
        <Space direction="vertical" size={0}>
          <Button type="primary">
            <RollbackOutlined />
            <Link to={homeLink[1]}> {homeLink[0]}</Link>
          </Button>
          {aktCopyText && (
            <>
              &nbsp;
              <CopyToClipboard
                text={aktCopyText}
                onCopy={() => setCopyState(true)}
              >
                {!copyState ? (
                  <Button>
                    <CopyOutlined />
                    Kopieren
                  </Button>
                ) : (
                  <Button>
                    <CheckOutlined />
                    Kopiert
                  </Button>
                )}
              </CopyToClipboard>
            </>
          )}
            </Space>
        </div>
      </div>
      <PendingComp isPending={isPending} />
    </>
  );
};
